export default __webpack_public_path__ + "static/media/no-user.73b200ad.png";